const _constant = {};
_constant.ERROR_MESSAGE = {};

_constant.ERROR_CODE = {
  4001: '4001',
  4002: '4002',
  4003: '4003'
};

_constant.ERROR_MESSAGE[_constant.ERROR_CODE['4001']] =
  'merchant configuration should not be empty or blank';
_constant.ERROR_MESSAGE[_constant.ERROR_CODE['4002']] = 'token session expired';
_constant.ERROR_MESSAGE[_constant.ERROR_CODE['4003']] = 'error occur while fetching paymodes';

export default _constant;



// WEBPACK FOOTER //
// ./utils/error-codes.js